import { Box, Typography } from '@mui/material';
import { Gauge } from '@mui/x-charts';
import { useLanguage } from '../../../utils/i18n';

export default function RPMGauge({ value = 0 }) {
  const { t } = useLanguage();
  const displayValue = value || 0;
  return (
    <Box sx={{ border: 1, borderRadius: 1, p: 1, borderColor: '#e1e1e1', textAlign: 'center', minWidth: 60 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1a237e', fontSize: 12 }}>
        {t('mapsTracking.rpm', 'RPM')}
      </Typography>
      <Box sx={{ width: 60, height: 60, mx: 'auto', position: 'relative' }}>
        <Gauge
          value={Number(displayValue)}
          valueMax={3000}
          startAngle={-110}
          endAngle={110}
          innerRadius="70%"
          outerRadius="100%"
          sx={{
            '& .MuiGauge-valueArc': { fill: '#3f51b5' },
            fontSize: 11
          }}
        />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 0.5, mt: 1 }}>
        <Typography sx={{ fontSize: 10 }}>0</Typography>
        <Typography sx={{ fontSize: 10 }}>3000</Typography>
      </Box>
    </Box>
  );
}
